// 竞价地区文件国家code码
// 注意仅仅保留第国家节点，其他节点升级成通过接口获取数据，本文件不推荐使用。

export const BidRegion = [
  {
    id: 6252001,
    code: 'US',
    name: 'america',
  },
  {
    id: 3469034,
    code: 'BR',
    name: 'brazil',
  },
  {
    id: 1861060,
    code: 'JP',
    name: 'japan',
  },
  {
    id: 1269750,
    code: 'IN',
    name: 'india',
  },
  {
    id: 2635167,
    code: 'GB',
    name: 'uk',
  },
  {
    id: 2921044,
    code: 'DE',
    name: 'germany',
  },
  {
    id: 3017382,
    code: 'FR',
    name: 'france',
  },
  {
    id: 3175395,
    code: 'IT',
    name: 'italy',
  },
  {
    id: 2510769,
    code: 'ES',
    name: 'spain',
  },
  {
    id: 2017370,
    code: 'RU',
    name: 'russia',
  },
  { id: 660013, code: 'FI', name: 'finland' },
  { id: 2661886, code: 'SE', name: 'sweden' },
  { id: 3996063, code: 'MX', name: 'mexico' },
  { id: 798544, code: 'PL', name: 'poland' },
  { id: 3865483, code: 'AR', name: 'argentina' },
  { id: 6251999, code: 'CA', name: 'canada' },
  {
    id: 357994,
    code: 'EG',
    name: 'egypt',
  },
  { id: 2750405, code: 'NL', name: 'netherlands' },
  {
    id: 298795,
    code: 'TR',
    name: 'turkey',
  },
  { id: 2077456, code: 'AU', name: 'australia' },
  { id: 3686110, code: 'CO', name: 'colombia' },
  {
    id: 102358,
    code: 'SA',
    name: 'saudi-arabia',
  },
  {
    id: 290557,
    code: 'AE',
    name: 'united-arab-emirates',
  },
  { id: 953987, code: 'ZA', name: 'south-africa' },
  { id: 2589581, code: 'DZ', name: 'algeria' },
  { id: 2542007, code: 'MA', name: 'morocco' },
  { id: 285570, code: 'KW', name: 'kuwait' },
  {
    id: 1605651,
    code: 'TH',
    name: 'thailand',
  },
  {
    id: 1562822,
    code: 'VN',
    name: 'vietnam',
  },
  {
    id: 1835841,
    code: 'KR',
    name: 'korea',
  },
  {
    id: 1643084,
    code: 'ID',
    name: 'indonesia',
  },
  { id: 1668284, code: 'TW', name: 'taiwan' },
  { id: 1819730, code: 'HK', name: 'hongkong' },
  { id: 1694008, code: 'PH', name: 'philippines' },
  {
    id: 1733045,
    code: 'MY',
    name: 'malaysia',
  },
  {
    id: 6251999,
    code: 'CA',
    name: 'canada',
  },
  { id: 286963, code: 'OM', name: 'Oman' },
  { id: 289688, code: 'QA', name: 'Qatar' },
  { id: 290291, code: 'BH', name: 'Bahrain' },
  { id: 294640, code: 'IL', name: 'Israel' },
  { id: 390903, code: 'GR', name: 'Greece' },
  { id: 630336, code: 'BY', name: 'Belarus' },
  { id: 690791, code: 'UA', name: 'Ukraine' },
  { id: 719819, code: 'HU', name: 'Hungary' },
  { id: 798549, code: 'RO', name: 'Romania' },
  { id: 1168579, code: 'PK', name: 'pakistan' },
  { id: 1522867, code: 'KZ', name: 'Kazakhstan' },
  { id: 1831722, code: 'KH', name: 'cambodia' },
  { id: 1880251, code: 'SG', name: 'singapore' },
  { id: 2186224, code: 'NZ', name: 'New Zealand' },
  { id: 2264397, code: 'PT', name: 'Portugal' },
  { id: 2623032, code: 'DK', name: 'Denmark' },
  { id: 2658434, code: 'CH', name: 'Switzerland' },
  { id: 2782113, code: 'AT', name: 'Austria' },
  { id: 2802361, code: 'BE', name: 'Belgium' },
  { id: 2963597, code: 'IE', name: 'Ireland' },
  { id: 3077311, code: 'CZ', name: 'Czechia' },
  { id: 3144096, code: 'NO', name: 'Norway' },
  { id: 3895114, code: 'CL', name: 'Chile' },
  { id: 3932488, code: 'PE', name: 'Peru' },
];

// 隐藏印度3级地域
// const filterCitys = ['IN'];
// const filterChildren = (regs = [], level = 0, countryCode = '') => {
//   const l = level + 1;
//   Object.keys(regs).forEach((key) => {
//     const curObj = regs[key];
//     const code = curObj.code || countryCode;
//     // 如果有children属性，则递归进去
//     if (filterCitys.includes(code) && curObj.children && curObj.children.length > 0) {
//       if (l === 2) {
//         delete curObj.children;
//       } else {
//         filterChildren(curObj.children, l, code);
//       }
//     }
//   });
//   return regs;
// };

// export const BidRegion = filterChildren(BidRegionOld, 0, '');

export const BidRegionMap = BidRegion.reduce((pre, cur) => {
  pre[cur.code] = cur.id;
  return pre;
}, {});


/**
 * 将国家的 code 转成对应的 id
 *
 * @export
 * @param {*} codeList code 列表
 * @returns
 */
export function countryCodeToId(codeList = []) {
  if (!codeList) {
    return [];
  }
  return codeList.map((code) => {
    const target = BidRegion.find(country => country.code === code);
    return target?.id;
  });
}

/**
 * 将国家的 id 转成 code
 *
 * @export
 * @param {*} idList id 列表
 * @returns
 */
export function countryIdToCode(idList = []) {
  if (!idList) {
    return [];
  }
  return idList.map((id) => {
    const target = BidRegion.find(country => country.id === id);
    return target?.code;
  });
}
